import React from "react";

const TabClientUsers = ({ clientUsers }) => {
  return <></>;
};

export default TabClientUsers;
